import { jsx as _jsx } from "react/jsx-runtime";
export default function defaultRenderGlyph(_ref) {
  let {
    key,
    color,
    x,
    y,
    size,
    onBlur,
    onFocus,
    onPointerMove,
    onPointerOut,
    onPointerUp
  } = _ref;
  return /*#__PURE__*/_jsx("circle", {
    className: "visx-circle-glyph",
    tabIndex: onBlur || onFocus ? 0 : undefined,
    fill: color,
    r: size / 2,
    cx: x,
    cy: y,
    onBlur: onBlur,
    onFocus: onFocus,
    onPointerMove: onPointerMove,
    onPointerOut: onPointerOut,
    onPointerUp: onPointerUp
  }, key);
}